// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/2.4.0/js/" + chunkId + "." + {"vendors-node_modules_emotion_css_dist_emotion-css_esm_js-node_modules_dayjs_plugin_customPars-3e0e8b":"04304c71","pages-ReservationList":"23ba5ef9"}[chunkId] + ".chunk.js";
};